export const objOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Banca premium",
  heading: "Transazioni illimitate senza commissioni",
  description:
    "Acquista tramite la nostra app esclusiva che ti permette di effetturare transazioni illimitate senza commissioni.",
  buttonLabel: "Scarica ora",
  imgStart: false,
  imgSrc: "images/svg-1.svg",
  alt: "Grafico",
  dark: true,
  primary: true,
  darkText: false,
}

export const objTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Accesso illimitato",
  heading: "Accedi al tuo conto ovunque",
  description:
    "Accedi al tuo conto ovunque, in qualsiasi momento. Basta una connessione a internet e un cellulare o un computer.",
  buttonLabel: "Scopri di più",
  imgStart: true,
  imgSrc: "images/svg-2.svg",
  alt: "Salvadanaio",
  dark: false,
  primary: false,
  darkText: true,
}

export const objThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Unisciti al team",
  heading: "Creare un account è facilissimo",
  description:
    "Bastano 10 minuti per creare il tuo nuovo account. Inserisci le tue informazioni personali ed il gioco è fatto.",
  buttonLabel: "Inizia ora",
  imgStart: false,
  imgSrc: "images/svg-3.svg",
  alt: "Documento",
  dark: false,
  primary: false,
  darkText: true,
}
